import { useState, useEffect } from 'react';
import styles from './LoadingOverlay.module.css';

const defaultMessages = ['Loading...'];

const LoadingOverlay = ({ isLoading, messages = defaultMessages }) => {
  const [message, setMessage] = useState(messages[0]);

  useEffect(() => {
    let intervalId;
    if (isLoading) {
      let currentIndex = 0;
      setMessage(messages[0]);
      intervalId = setInterval(() => {
        if (currentIndex < messages.length - 1) {
          currentIndex++;
          setMessage(messages[currentIndex]);
        }
      }, 3000);
    }
    return () => clearInterval(intervalId);
  }, [isLoading, messages]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.contentBox}>
        <div className={styles.spinner}></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
